import React from "react";
import classNames from "classnames";

import styles from "./Layout.css";

export default function Layout({ includeHeader, headerComponent, children, className }) {
  return (
    <div>
      {includeHeader && headerComponent || null}
      <div className={classNames(styles.root, className)}>
        {children}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Library/Layout/Layout.js